var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"py-2"},[(_vm.getBreadcrumbs.length)?_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.getBreadcrumbs),function(breadcrumb,i){return _c('BreadcrumbItem',{key:i,attrs:{"item":breadcrumb}})}),1)]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }